<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<div class="title-chapter"><a href="#/e9781429998314_toc01#toctitle2" id="title2"><span><strong class="b">Characters</strong></span></a></div>
<div class="tableau"><table class="none">
<colgroup><col width="21.98*"/>
<col width="9.89*"/>
<col width="68.13*"/>
</colgroup><tbody><tr>
<td align="left" class="filet_x filet_x " valign="top"><strong class="b">MAN</strong></td>
<td align="left" class="filet_x filet_x " rowspan="3" valign="middle"><span class="imageinline"><img alt="e9781429998314_i0003.jpg" height="113px" src="e9781429998314_i0003.jpg" width="27px"/></span></td>
<td align="left" class="filet_x filet_x " valign="top"></td></tr>
<tr>
<td align="left" class="filet_x filet_x " valign="top"><strong class="b">WOMAN</strong></td>
<td align="left" class="filet_x filet_x " valign="top">Three people in their thirties</td></tr>
<tr>
<td align="left" class="filet_x filet_x " valign="top"><strong class="b">CODY</strong></td>
<td align="left" class="filet_x filet_x " valign="top"></td></tr></tbody></table></div>
<div class="p"><span><strong class="b">WAITRESS</strong> A woman in her twenties</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429998314_c01.vue?45530bbe